import { Stack, Text, useTheme, Box } from '@ltvco/refresh-lib/theme';
import { AutoAwesomeOutlined } from '@mui/icons-material';

interface IAnalysisCompletedMessageProps {
  /** Type of analysis being performed (e.g., "repair costs", "vehicle value") */
  analysisType: string;
  /** Primary dynamic value to highlight (e.g., repair type, vehicle model) */
  primaryValue: string;
  /** Secondary dynamic value to highlight (e.g., vehicle year/make/model) */
  secondaryValue: string;
  /** Location or area value to highlight */
  location: string;
}

export const AnalysisCompletedMessage = ({
  analysisType,
  primaryValue,
  secondaryValue,
  location,
}: IAnalysisCompletedMessageProps) => {
  const theme = useTheme();

  return (
    <Box
      width="100%"
      borderRadius={2}
      p={2}
      sx={{
        backgroundColor: 'background.default',
      }}
    >
      <Stack direction="row" alignItems="flex-start" gap={1.5}>
        <AutoAwesomeOutlined
          sx={{
            color: theme.palette.primary.main,
            mt: 0.5,
          }}
        />
        <Stack direction="column" gap={0.5}>
          <Text variant="body1" component="div">
            I've analyzed {analysisType} on{' '}
            <strong>{primaryValue.toLowerCase()}</strong> for{' '}
            <strong>{secondaryValue}</strong> in the{' '}
            <strong>{location?.toUpperCase()}</strong> area. Here's what you
            should expect to pay:
          </Text>
        </Stack>
      </Stack>
    </Box>
  );
};
